document.addEventListener('DOMContentLoaded', function () {
  const moneyFormat = window.themeCore?.objects?.shop?.money_format || '${{amount}}';
  const moneyWithCurrencyFormat = window.themeCore?.objects?.shop?.money_with_currency_format || '${{amount}}';

  function formatMoney(cents, format) {
    if (window.themeCore?.utils?.formatMoney) {
      return window.themeCore.utils.formatMoney(cents, format);
    }
    return cents;
  }

  function updateMainProductPrice(container, variant) {
    if (!container || !variant) return;

    const priceContainers = container.querySelectorAll('.js-main-product-price');
    if (!priceContainers.length) return;

    priceContainers.forEach((priceContainer) => {
      const isCurrencyEnabled = priceContainer.hasAttribute('data-currency-code-enabled');
      const format = isCurrencyEnabled ? moneyWithCurrencyFormat : moneyFormat;

      const price = variant.price;
      const compareAtPrice = variant.compare_at_price;
      const onSale = compareAtPrice && compareAtPrice > price;

      const moneyPrice = formatMoney(price, format);
      const moneyCompareAt = compareAtPrice ? formatMoney(compareAtPrice, format) : '';

      const currentPriceEls = priceContainer.querySelectorAll('[data-product-price]');
      const oldPriceEls = priceContainer.querySelectorAll('[data-price-old]');
      const saleBlock = priceContainer.querySelector('.price__sale');
      const regularBlock = priceContainer.querySelector('.price__regular');

      currentPriceEls.forEach((el) => {
        el.textContent = moneyPrice;
        el.setAttribute('data-amount', price);
      });

      oldPriceEls.forEach((el) => {
        el.textContent = onSale ? moneyCompareAt : '';
      });

      priceContainer.classList.toggle('price--on-sale', !!onSale);

      if (saleBlock && regularBlock) {
        saleBlock.style.display = onSale ? '' : 'none';
        regularBlock.style.display = onSale ? 'none' : '';
      }
    });
  }

  document.querySelectorAll('[data-js-product-form]').forEach((form) => {
    const productSection = form.closest('[data-section-type="product"]');
    if (!productSection) return;

    const sectionId = productSection.getAttribute('data-section-id');
    if (!sectionId || !window.themeCore?.EventBus) return;

    window.themeCore.EventBus.listen(`pdp:section-${sectionId}:change-variant`, function ({ variant }) {
          console.log('variant changed', variant);

      updateMainProductPrice(form, variant);
    });
  });
});
// Hide duplicate Omega quote buttons in recommendations
document.addEventListener('DOMContentLoaded', function() {
  const seen = new Set();
  document.querySelectorAll('[id^="omg-hide-price-form"]').forEach(el => {
    const card = el.closest('.product-recommendations__col');
    if (!card) return;
    if (seen.has(card)) {
      el.style.display = 'none';
    } else {
      seen.add(card);
    }
  });
});